import React from 'react';
import { allowedTab, findTabByUrl } from '@/layout/layoutManagerTabs';
import Selectors from '@/layout/hooks/selectors';
import RibbonMenuActions from '@/components/ribbon-actions/RibbonMenuActions';

const RibbonActions = () => {
  const state = Selectors.useRibbonActions();
  const tab = findTabByUrl(state.url);
  const { Ribbon } = allowedTab(tab, state);

  return (
    <RibbonMenuActions fullscreen={state.fullscreen}>
      {state.approved && Ribbon && (<Ribbon category={state.category} code={state.code} url={state.url} />)}
    </RibbonMenuActions>
  );
};

export default RibbonActions;
